import { Question } from '@/types/qa'

import { QuestionAnswerMutationTypes } from './mutation_types'
import { QuestionAnswerState } from './state'

export const mutations: StoreMutations<QuestionAnswerMutationTypes, QuestionAnswerState> = {
  [QuestionAnswerMutationTypes.SET_QUESTIONS_PENDING] (state, value) {
    state.questionsPending = value
  },
  [QuestionAnswerMutationTypes.SET_QUESTIONS] (state, value) {
    state.questions = value
  },
  [QuestionAnswerMutationTypes.SET_DELETE_QUESTION_PENDING] (state, value) {
    state.deleteQuestionPending = value
  },
  [QuestionAnswerMutationTypes.REMOVE_QUESTION_FROM_LIST] (state, questionId) {
    const questionIndex = state.questions.questions.findIndex((question: Question) => question.id === questionId)

    if (questionIndex >= 0) {
      state.questions.questions.splice(questionIndex, 1)
    }
  },
  [QuestionAnswerMutationTypes.SET_CATEGORIES_PENDING] (state, value) {
    state.categoriesPending = value
  },
  [QuestionAnswerMutationTypes.SET_CATEGORIES] (state, value) {
    state.categories = value
  },
  [QuestionAnswerMutationTypes.SET_UPDATE_QUESTION_IN_LIST] (state, questionToUpdate) {
    const questionIndex = state.questions.questions.findIndex((question: Question) => question.id === questionToUpdate.id)

    if (questionIndex >= 0) {
      state.questions.questions[questionIndex] = questionToUpdate
    }
  },
  [QuestionAnswerMutationTypes.SET_POST_QUESTION_PENDING] (state, value) {
    state.postQuestionPending = value
  },
  [QuestionAnswerMutationTypes.SET_PATCH_QUESTION_PENDING] (state, value) {
    state.patchQuestionPending = value
  },
  [QuestionAnswerMutationTypes.SET_QUESTION_PENDING] (state, value) {
    state.questionPending = value
  },
  [QuestionAnswerMutationTypes.SET_QUESTION] (state, value) {
    state.question = value
  },
  [QuestionAnswerMutationTypes.SET_POST_ANSWER_PENDING] (state, value) {
    state.postAnswerPending = value
  },
  [QuestionAnswerMutationTypes.SET_PATCH_QUESTION_RIGHTS_PENDING] (state, value) {
    state.patchQuestionRightsPending = value
  },
  [QuestionAnswerMutationTypes.SET_QUESTIONS_BULK_RIGHTS_PENDING] (state, value) {
    state.questionsBulkRightsPending = value
  },
  [QuestionAnswerMutationTypes.SET_FILTERS_PANE_IS_OPEN] (state, value) {
    state.filtersPaneIsOpen = value
  },
  [QuestionAnswerMutationTypes.SET_FILTERS] (state, value) {
    state.filters = value
  },
  [QuestionAnswerMutationTypes.REMOVE_FILTER] (state, filterToRemove) {
    state.filters = state.filters.filter(
      (filter: Filter) => filter.category.key !== filterToRemove.category.key || filter.value.key !== filterToRemove.value.key,
    )
  },
  [QuestionAnswerMutationTypes.ADD_ANSWER_TO_QUESTION] (state, { questionId, answer }) {
    if (state.question?.id === questionId) {
      state.question?.answers?.push(answer)
    }
  },
  [QuestionAnswerMutationTypes.SET_MARK_QUESTION_AS_ANSWERED_PENDING] (state, value) {
    state.markQuestionAsResolvedPending = value
  },
  [QuestionAnswerMutationTypes.SET_IMPORT_QUESTIONS_PENDING] (state, value) {
    state.importQuestionsPending = value
  },
  [QuestionAnswerMutationTypes.SET_QUESTION_PARTICIPANTS_PENDING] (state, value) {
    state.questionParticipantsPending = value
  },
  [QuestionAnswerMutationTypes.SET_QUESTION_PARTICIPANTS] (state, value) {
    state.questionParticipants = {
      author: value?.author || null,
      users: value?.users || [],
      groups: value?.groups || [],
    }
  },
}
